import { createFileRoute } from "@tanstack/react-router";
import { footprintListInfiniteQueryOptions } from "~/features/footprint/api";
import { FootprintTemplate } from "~/features/footprint/FootprintTemplate";

export const Route = createFileRoute("/_authenticated/profile/footprint")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureInfiniteQueryData(footprintListInfiniteQueryOptions),
  component: FootprintTemplate,
});
